import React from 'react';
import { styled } from 'styled-components';
import THEME from '../theme.js';
const RadioStyledStyled = styled.div `
  font-weight: ${(props) => (props.active ? '900' : '300')};
  cursor: pointer;
  margin-right: 20px;
  display: inline-block;
  line-height: 1.5em;
  user-select: none;
`;
const Radio = styled.div `
  height: 1em;
  width: 1em;
  border-radius: 100%;
  border: 1px solid ${THEME.COLOR_PRIMARY};
  display: inline-block;
  margin: 3px 7px -3px 0;
  position: relative;

  &::after {
    content: ' ';
    height: 0.75em;
    width: 0.75em;
    border-radius: 100%;
    position: absolute;
    background-color: ${(props) => props.active ? THEME.COLOR_PRIMARY : 'transparent'};
    top: 0.0625em;
    left: 0.0625em;
  }
`;
const RadioStyled = (props) => (React.createElement(RadioStyledStyled, { ...props },
    React.createElement(Radio, { active: props.active }),
    props.label));
export default RadioStyled;
//# sourceMappingURL=RadioSelect.js.map